function openModal(img) {
    let modal = document.createElement('div');
    modal.style.position = 'fixed';
    modal.style.top = '0';
    modal.style.bottom = '0';
    modal.style.left = '0';
    modal.style.right = '0';
    modal.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
    modal.style.display = 'grid';
    modal.style.alignItems = 'center';
    modal.style.justifyContent = 'center';
  
    let modalImg = document.createElement('img');
    modalImg.src = img.src;
    modalImg.style.maxWidth = '85vw';
    modalImg.style.maxHeight = '85vh';
    modalImg.style.objectFit = 'contain';
  
    modal.appendChild(modalImg);
    modal.addEventListener('click', function() {
      modal.parentElement.removeChild(modal);
    });
    document.body.appendChild(modal);
}

function openWindow(windowNum) {
    let window = document.querySelector('.' + windowNum);
    window.style.zIndex = '10';
    window.style.opacity = '1';
}

function closeWindow(windowNum) {
    let window = document.querySelector('.' + windowNum);
    window.style.zIndex = '-2';
    window.style.opacity = '0';
}

let Window1 = document.querySelector('.Window1');

Window1.addEventListener('click', function() {
    Window1.style.zIndex = '-2';
    Window1.style.opacity = '0';
});

let Window2 = document.querySelector('.Window2');

Window2.addEventListener('click', function() {
    Window2.style.zIndex = '-2';
    Window2.style.opacity = '0';
});

let Window3 = document.querySelector('.Window3');

Window3.addEventListener('click', function() {
    Window3.style.zIndex = '-2';
    Window3.style.opacity = '0';
});

let WindowContent = document.querySelectorAll('.Window_Content');

WindowContent.forEach(function(el){
    el.addEventListener('click', function() {
        event.stopPropagation();
    });
});

const slideUp = (el, duration = 300) => {
    el.style.height = el.offsetHeight + "px";
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    setTimeout(() => {
        el.style.display = "none";
        el.style.removeProperty("height");
        el.style.removeProperty("padding-top");
        el.style.removeProperty("padding-bottom");
        el.style.removeProperty("margin-top");
        el.style.removeProperty("margin-bottom");
        el.style.removeProperty("overflow");
        el.style.removeProperty("transition-duration");
        el.style.removeProperty("transition-property");
        el.style.removeProperty("transition-timing-function");
        el.classList.remove("is-open");
    }, duration);
};
  
const slideDown = (el, duration = 300) => {
    el.classList.add("is-open");
    el.style.removeProperty("display");
    let display = window.getComputedStyle(el).display;
    if (display === "none") {
        display = "grid";
    }
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.height = height + "px";
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    setTimeout(() => {
        el.style.removeProperty("height");
        el.style.removeProperty("overflow");
        el.style.removeProperty("transition-duration");
        el.style.removeProperty("transition-property");
        el.style.removeProperty("transition-timing-function");
    }, duration);
};
  

const slideToggle = (el, duration = 300) => {
    if (window.getComputedStyle(el).display === "none") {
        return slideDown(el, duration);
    } else {
        return slideUp(el, duration);
    }
};
  
const accordions = document.querySelectorAll(".js-accordion");
const accordionsArr = Array.prototype.slice.call(accordions);
  
accordionsArr.forEach((accordion) => {
    const accordionTriggers = accordion.querySelectorAll(".js-accordion-trigger");
    const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);
  
    accordionTriggersArr.forEach((trigger) => {
        trigger.children[0].addEventListener("click", () => {
            trigger.classList.toggle("is-active");
            const content = trigger.querySelector(".accordion__content");
            slideToggle(content);
        });
    });
});